import { Route } from "@angular/router";
import { AuthGuard } from "./core/auth/guards/auth.guard";
import { LayoutComponent } from "./layout/layout.component";
import { ConfirmationModalDemoComponent } from "./modules/components/demo/confirmation-modal-demo/confirmation-modal-demo.component";

/**
 * Development Routes
 * These routes are only available in development/QA environments
 * They are excluded from production builds for security and performance
 */
export const devRoutes: Route[] = [
    // Routes for preview/demo of components
    {
        path: "preview",
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: "empty",
            breadcrumb: "Preview"
        },
        children: [
            {
                path: "confirmation-modal",
                component: ConfirmationModalDemoComponent,
                data: { breadcrumb: "Confirmation Modal" },
            },
            // Future dev routes can be added here
        ],
    },
];

